import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const http = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const formatDetail = (d) => {
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d && typeof d.message === "string") return d.message;
  return "Something went wrong. Please try again.";
};

export const openSignedDownload = async (linkEndpoint) => {
  const { data } = await http.get(linkEndpoint);
  window.open(`${BACKEND}${data.url}`, "_blank");
};

export const auDateTime = (iso) =>
  new Date(iso).toLocaleString("en-AU", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
